import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.1.1?node-id=9409%3A25690
 *
 * @param {SvgIconProps} props - svg props
 */
type ShowDialerButtonIconProps = SvgIconProps & {
    secondaryColor?: string
    size?: number
}

export const ShowDialerButtonIcon = ({
    secondaryColor = 'white',
    color = '#30991C',
    size = 44,
    style,
    ...svgProps
}: ShowDialerButtonIconProps): JSX.Element => {
    return (
        <SvgIcon
            {...svgProps}
            viewBox='0 0 48 48'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{
                width: size,
                height: size,
                ...style
            }}
        >
            <g filter='url(#show-dialer-shadow)'>
                <rect
                    x='4'
                    y='1'
                    width='40'
                    height='40'
                    rx='20'
                    fill={color}
                />

                <path
                    d='M24.0005 29.0417C25.0473 29.0419 25.8958 29.8904 25.896 30.9372C25.896 31.9841 25.0474 32.8335 24.0005 32.8337C22.9534 32.8337 22.104 31.9842 22.104 30.9372C22.1042 29.8903 22.9536 29.0417 24.0005 29.0417ZM18.0415 23.0837C19.0885 23.0837 19.938 23.9321 19.938 24.9792C19.938 26.0262 19.0885 26.8747 18.0415 26.8747C16.9946 26.8745 16.146 26.0261 16.146 24.9792C16.146 23.9323 16.9946 23.0839 18.0415 23.0837ZM24.0005 23.0837C25.0474 23.0839 25.896 23.9323 25.896 24.9792C25.896 26.0261 25.0474 26.8745 24.0005 26.8747C22.9534 26.8747 22.104 26.0262 22.104 24.9792C22.104 23.9321 22.9534 23.0837 24.0005 23.0837ZM29.9585 23.0837C31.0055 23.0837 31.854 23.9321 31.854 24.9792C31.854 26.0262 31.0055 26.8747 29.9585 26.8747C28.9115 26.8747 28.063 26.0262 28.063 24.9792C28.063 23.9321 28.9115 23.0837 29.9585 23.0837ZM18.0415 17.1247C19.0885 17.1247 19.938 17.9741 19.938 19.0212C19.9378 20.0681 19.0884 20.9167 18.0415 20.9167C16.9947 20.9165 16.1462 20.068 16.146 19.0212C16.146 17.9742 16.9946 17.1249 18.0415 17.1247ZM24.0005 17.1247C25.0474 17.1249 25.896 17.9742 25.896 19.0212C25.8958 20.068 25.0473 20.9165 24.0005 20.9167C22.9536 20.9167 22.1042 20.0681 22.104 19.0212C22.104 17.9741 22.9534 17.1247 24.0005 17.1247ZM29.9585 17.1247C31.0055 17.1247 31.854 17.9741 31.854 19.0212C31.8538 20.0681 31.0054 20.9167 29.9585 20.9167C28.9116 20.9167 28.0632 20.0681 28.063 19.0212C28.063 17.9741 28.9115 17.1247 29.9585 17.1247ZM18.0415 11.1667C19.0884 11.1667 19.9378 12.0153 19.938 13.0622C19.938 14.1092 19.0885 14.9587 18.0415 14.9587C16.9946 14.9585 16.146 14.1091 16.146 13.0622C16.1462 12.0154 16.9947 11.1669 18.0415 11.1667ZM24.0005 11.1667C25.0473 11.1669 25.8958 12.0154 25.896 13.0622C25.896 14.1091 25.0474 14.9585 24.0005 14.9587C22.9534 14.9587 22.104 14.1092 22.104 13.0622C22.1042 12.0153 22.9536 11.1667 24.0005 11.1667ZM29.9585 11.1667C31.0054 11.1667 31.8538 12.0153 31.854 13.0622C31.854 14.1092 31.0055 14.9587 29.9585 14.9587C28.9115 14.9587 28.063 14.1092 28.063 13.0622C28.0632 12.0153 28.9116 11.1667 29.9585 11.1667Z'
                    fill={secondaryColor}
                />
            </g>

            <defs>
                <filter
                    id='show-dialer-shadow'
                    x='0'
                    y='0'
                    width='48'
                    height='48'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                >
                    <feDropShadow
                        dx='0'
                        dy='3'
                        stdDeviation='2'
                        floodColor='black'
                        floodOpacity='0.1'
                    />
                </filter>
            </defs>
        </SvgIcon>
    )
}

export default ShowDialerButtonIcon
